<template>
    <div>
        <div v-if="creatorGallery.secret">
            <font-awesome-icon
                icon="fa-duotone fa-face-shush"
                class="branded"
            />
            {{ $t("Secret") }}
        </div>
        <div v-else>
            <font-awesome-icon
                icon="fa-duotone fa-globe"
                class="text-primary"
            />
            {{ $t("Public") }}
        </div>
    </div>
</template>

<script>
export default {
    props: ["creatorGallery"],
};
</script>